import React, { FC } from 'react'

import { tips } from '../locales'
import './styles.scss'

export interface NoAddressTipProps {
  type: string,
}

const NoAddressTip:FC<NoAddressTipProps> = ({
  type
}) => {

  return (
    <p className="b3-noAddress-notAddNewAddress-tip">
      {
        type === 'shipping' ? tips['b3.shipping.noAddress.notAddNewAddress.tip'] : tips['b3.billing.noAddress.notAddNewAddress.tip']
      }
    </p>
  )
}

export default NoAddressTip